export const STUDY_OBJECT_TYPE = 'clinicalStudy';

export const STIM = 'STIM';
export const BASESTATION = 'BASESTATION';
export const BAND = 'BAND';
